import React, { FC, memo } from 'react';

import styles from './PreviewLabel.module.scss';

type PreviewLabelProps = {
  title: string;
};

export const PreviewLabel: FC<PreviewLabelProps> = memo(({ title }) => (
  <span className={styles.root}>{title}</span>
));
